import type { UnitPreference } from '../types';

type UnitToggleProps = {
  value: UnitPreference;
  onChange: (next: UnitPreference) => void;
  size?: 'sm' | 'md';
};

export function UnitToggle({ value, onChange }: UnitToggleProps) {
  return (
    <div className="toggle" role="tablist" aria-label="Units">
      <button
        type="button"
        className={`toggle__btn${value === 'metric' ? ' toggle__btn--on' : ''}`}
        onClick={() => onChange('metric')}
        role="tab"
        aria-selected={value === 'metric'}
      >
        Metric
      </button>
      <button
        type="button"
        className={`toggle__btn${value === 'imperial' ? ' toggle__btn--on' : ''}`}
        onClick={() => onChange('imperial')}
        role="tab"
        aria-selected={value === 'imperial'}
      >
        Imperial
      </button>
    </div>
  );
}
